<div class="d-flex h-100 flex-column">
  <!-- Top toolbar -->
  <div class="flex-shrink-0">
    <mat-toolbar class="app-toolbar">
      <span class="toolbar-brand">ProWoDo</span>
      @if (companyName$ | async; as company) {
        <span class="toolbar-breadcrumb ms-3">
          {{ company }}
          @if (projectTitle$ | async; as project) {
            <span class="toolbar-breadcrumb-sep">/</span>
            {{ project }}
          }
        </span>
      }
      <span class="spacer"></span>
      <a
        [routerLink]="['/', 'notifications', 'history']"
        class="toolbar-icon-btn"
        title="Notifications"
        [matBadge]="(unreadCount$ | async) || null"
        matBadgeColor="warn"
        matBadgeSize="small"
        matBadgePosition="below after"
      >
        <mat-icon fontSet="material-symbols-outlined">notifications</mat-icon>
      </a>
      @if (auth.user | async; as user) {
        <a
          [routerLink]="['/', 'profile']"
          class="toolbar-avatar ms-2"
          title="Profile"
          [style.background-image]="'url(' + user.photoURL + ')'"
        >
        </a>
      } @else {
        <div class="toolbar-avatar-placeholder ms-2"></div>
      }
      <button
        mat-icon-button
        aria-label="Menu"
        (click)="toggleMobileMenu()"
        class="d-block d-md-none ms-1"
      >
        <mat-icon fontSet="material-symbols-outlined">menu</mat-icon>
      </button>
    </mat-toolbar>
  </div>

  <!-- Content: sidebar + main -->
  <div class="flex-grow-1 overflow-hidden">
    <mat-sidenav-container class="h-100">
      <mat-sidenav
        #sidenavBar
        mode="side"
        opened
        class="side-bar h-100 overflow-y-auto d-none d-md-block"
      >
        <app-side-menu></app-side-menu>
      </mat-sidenav>
      <mat-sidenav
        #mobileMenu
        position="end"
        mode="over"
        class="mobile-menu h-100 overflow-y-auto ps-md-3 pt-md-3 w-100 d-block d-md-none"
      >
        <app-side-menu (clickOnVoice)="clickOnVoice()"></app-side-menu>
      </mat-sidenav>
      <mat-sidenav-content class="h-100 overflow-y-auto">
        <ng-content></ng-content>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>
